import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7FIAIssuerTSSchema = z.object({
  date_equals: z.string().optional(),
  denomination_du_sous_jacent_contains: z.string().optional(),
});

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "denomination_du_sous_jacent_contains",
    label: `Émetteur`,
    type: "input",
  },
];

export type FilterA7FIAIssuerTSSchema = z.infer<
  typeof filterA7FIAIssuerTSSchema
>;

export function FilterA7FIAIssuerTS({
  client,
  table_name,
}: {
  client: string;
  table_name: string;
}) {
  const { fields } = useDateOptions(client, table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7FIAIssuerTSSchema}
      client={client}
      tableName="a7_fia_issuer_ts"
      fields={fields}
      customBuildPath={() => `a7-fia/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
